<template>
  <div class="">
    <div class="bgImage">
      <div class="row">
        <div class="col-12">
          <div class="div-colab">
            <router-link to="/collaboration">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png" class="categoryImage" title="Collaboration">
            </router-link>
          </div>
          <div class="div-innovation">
            <router-link to="/innovation">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png" class="categoryImage" title="Innovation">
            </router-link>
          </div>
          <div class="div-report">
            <router-link to="/reporting">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_reporting.png" class="categoryImage" title="Reporting">
            </router-link>
          </div>
          <div class="div-design">
            <router-link to="/design">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_design.png" class="categoryImage" title="Design">
            </router-link>
          </div>
          <div class="div-management">
            <router-link to="/management">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_management.png" class="categoryImage" title="Management">
            </router-link>
          </div>
          <div class="div-commercial">
            <router-link to="/commercial">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_commercial.png" class="categoryImage" title="Commercial">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bg_gradient row">
    </div> -->
  </div>

</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPageNew',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>

.div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 551px;
}
.div-innovation {
  position: absolute;
  z-index: 1;
  top: 528px;
  left: 608px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1079px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1346px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1073px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1284px;
}

/* CENTERED BG */
/* .div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 636px;
}
.div-innovation {
  top: 528px;
  position: absolute;
  z-index: 1;
  left: 694px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1163px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1430px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1157px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1368px;
} */
</style>
